import { Item } from '@/helpers/Item'
import { Num } from '@/helpers/Math'
//import Availability from '@/helpers/Availability'
import * as CONST from '@/constants.js'
import axios from '@/utils/axios_iface'
import { getBaseUrl, convert_datetime } from '@/utils/main_utils'
//import router from '@/router/router'
import moment from 'moment-timezone'
export default {
  state: {
    items: [],
    selectedItem: undefined,
    openMobileCart: false,
    openmobilecartpayment: false,
    openCartSidebar: false,
    selectedModifiers: {},
    qty: 1,
    orderType: CONST.ORDER_TYPE_ONLINE,
    driverTip: '',
    loyalty: '5%',
    addressInstructions: '',
    order: undefined,
    orderId: undefined,
    orderNote: undefined,
    itemNote: undefined,
    loyaltySpent: undefined,
    modifierErrors: {},
    storeChangeWarn: false,
    reservationResponse: undefined,
    futureOrderDateTime: undefined,
    lastOrderRequest: undefined,
  },
  getters: {
    mobileCartIsOpened: state => state.openMobileCart,
    last_order_request: state => state.lastOrderRequest,
    reservationsData: state =>
      state.reservationResponse ? state.reservationResponse.id : false,

    future_order: state => state.futureOrderDateTime,
    currentDateTime: (state, getters) => {
      let timeZoneString = getters.getStoreTimezone
      let current_dt = undefined
      if (timeZoneString) {
        const currentTime = moment
          .tz(timeZoneString)
          .format('HH:mm A') /*  00:01 at midnight without A*/
        const currentDate = moment.tz(timeZoneString).format('YYYY/MM/DD')
        current_dt = { current_time: currentTime, current_date: currentDate }
      }
      return current_dt
      // commit('CURRENT_STORE_DATE_TIME', current_dt)
    },
    getStoreTimezone: (state, getters) => {
      let store = getters.currentStore
      const storeTimezone = getters.findTimezoneByStore(store)

      if (!storeTimezone) {
        return true
      }

      const timeZoneString = storeTimezone.name
        ? storeTimezone.name.split(' ')[0]
        : ''
      if (!timeZoneString) {
        return false
      }
      return timeZoneString
    },
    getStoreOpenCloseTimezone: (state, getters) => store => {
      let currentStore = store

      const storeTimezone = getters.findTimezoneByStore(currentStore)

      if (!storeTimezone) {
        return true
      }

      const timeZoneString = storeTimezone.name
        ? storeTimezone.name.split(' ')[0]
        : ''
      if (!timeZoneString) {
        return true
      }
      const storeTimings = currentStore.delivery_hours

      let openAt = getters.timeConvert(storeTimings.opens_at, 0)
      let closedAt = getters.timeConvert(storeTimings.closes_at, 0)
      if (openAt >= closedAt) {
        return true
      }
      const storeCurrentDate = moment.tz(timeZoneString).format('YYYY-MM-DD')
      const format = 'YYYY-MM-DD HH:mm'
      const storeTime = moment.tz(timeZoneString).format(format)

      const storeCurrentTime = moment.tz(
        storeTime,
        format,
        true,
        timeZoneString
      )

      const storeOpeningDateTime =
        storeCurrentDate + ' ' + storeTimings.opens_at

      const storeOpeningTime = moment.tz(
        storeOpeningDateTime,
        format,
        true,
        timeZoneString
      )

      const storeClosingDateTime =
        storeCurrentDate + ' ' + storeTimings.closes_at

      const storeClosingTime = moment.tz(
        storeClosingDateTime,
        format,
        true,
        timeZoneString
      )
      const currentTime = moment.tz(timeZoneString).format('YYYY-MM-DD hh:mm A')
      return {
        current_time: currentTime,
        store_current_time: storeCurrentTime,
        opening_time: storeOpeningTime,
        closing_time: storeClosingTime,
      }
    },
    isStoreOpen: (state, getters) => store => {
      let currentStore = store
      if (!currentStore && getters.cart_items_count) {
        currentStore = getters.cart_brand_store.store
      }

      const storeTimezone = getters.findTimezoneByStore(currentStore)

      if (!storeTimezone) {
        return true
      }

      const timeZoneString = storeTimezone.name
        ? storeTimezone.name.split(' ')[0]
        : ''
      if (!timeZoneString) {
        return true
      }
      const storeTimings = currentStore.open_hours

      // Store is open 24 hours
      if (storeTimings.all_day_long) {
        return true
      }
      /*
            let startTime = getters.timeConvert(storeTimings.opens_at, 1)
            let closedTime = getters.timeConvert(storeTimings.closes_at, 1)*/

      let openAt = getters.timeConvert(storeTimings.opens_at, 0)
      let closedAt = getters.timeConvert(storeTimings.closes_at, 0)
      if (openAt >= closedAt) {
        /*let timeSplit = storeTimings.closes_at.split(':')
                let calcTime = parseInt(openAt) + parseInt(closedAt) + 12 + (12 - openAt)
                // startTime += openAt
                closedTime = calcTime * 60 + parseInt(timeSplit[1])*/
        return true
      }
      const storeCurrentDate = moment.tz(timeZoneString).format('YYYY-MM-DD')
      const format = 'YYYY-MM-DD HH:mm'
      const storeTime = moment.tz(timeZoneString).format(format)

      const storeCurrentTime = moment.tz(
        storeTime,
        format,
        true,
        timeZoneString
      )

      const storeOpeningDateTime =
        storeCurrentDate + ' ' + storeTimings.opens_at

      const storeOpeningTime = moment.tz(
        storeOpeningDateTime,
        format,
        true,
        timeZoneString
      )

      const storeClosingDateTime =
        storeCurrentDate + ' ' + storeTimings.closes_at

      const storeClosingTime = moment.tz(
        storeClosingDateTime,
        format,
        true,
        timeZoneString
      )

      return storeCurrentTime.isBetween(storeOpeningTime, storeClosingTime)
    },
    /*deliveryTimeCalculate: (state, getters) => {
      if (state.store_current_date_time) {
        
        if (state.futureOrderDateTime) {
          const current_date_store = new Date(state.store_current_date_time.current_date)
          const current_date_active = new Date(state.futureOrderDateTime.future_date)
          if (current_date_active > current_date_store) {
            return false
          }
        }

        let time = getters.deliveryTime({delivery_duration : '0:' + state.store_current_date_time.current_time}, true)
        let store_close_time = getters.deliveryTime({delivery_duration : '0:' + getters.currentStore.delivery_hours.closes_at}, true)
        store_close_time = parseInt(store_close_time) - parseInt(getters.deliveryTime(getters.currentStore, true))
        if (time > store_close_time) {
          return true
        } else return false
      } else { return false }
    }*/

    future_order_format_date_time: (state, getters) => {
      /*let time_slote = state.futureOrderDateTime
      if (time_slote) {
        let date_time = time_slote.future_date + ' ' + time_slote.future_time.time_24_from_hours
        let utc_time = moment(date_time).utc().format('YYYY/MM/DD HH:mm')
        // let utc_time_c = moment.utc(date_time_timezone).format('YYYY/MM/DD HH:mm')
        return utc_time
      } else false*/
      let store = getters.currentStore
      const storeTimezone = getters.findTimezoneByStore(store)
      let time_slote = state.futureOrderDateTime
      if (time_slote && time_slote.future_date) {
        let date_time =
          time_slote.future_date +
          ' ' +
          time_slote.future_time.time_24_from_hours
        let date_converted_to_store = convert_datetime(
          date_time,
          'YYYY/MM/DD HH:mm',
          storeTimezone.value
        )
        return date_converted_to_store
      } else return false
    },
    date_time_format: () => (datetime, date_format = 'ddd, Do MMM YYYY') => {
      return moment(datetime).format(date_format)
    },
    /*future_order_format_date_time: (state, getters) => {
      let store = getters.currentStore
      const storeTimezone = getters.findTimezoneByStore(store)
      
      let time_slote = state.futureOrderDateTime
      let date_time = time_slote.future_date + ' ' + time_slote.future_time.time_24_from_hours
      let date_converted_to_store = convert_datetime(date_time, 'YYYY/MM/DD HH:mm', storeTimezone.value)
      let utc_time = moment(date_converted_to_store).utc().format('YYYY/MM/DD HH:mm')
      return utc_time
      /!*
      let timeZoneString = getters.getStoreTimezone
      let time_slote = state.futureOrderDateTime
      let store_tz = ''
      if (time_slote) {
        let date_time = time_slote.future_date + ' ' + time_slote.future_time.time_24_from_hours
        if(timeZoneString) {
          // date_time = datetime_in_store_timezone(date_time, timeZoneString, 'YYYY/MM/DD HH:mm')
          store_tz = moment(date_time)
              .tz(timeZoneString)
              .format('YYYY/MM/DD HH:mm')
        }
        let b = moment(date_time).format('YYYY/MM/DD HH:mm')
        // utc_time = moment(store_tz).utc().format('YYYY/MM/DD HH:mm')
       let a =  moment(b).tz(timeZoneString).utc().format('YYYY/MM/DD HH:mm')
        // let utc_time_c = moment.utc(date_time_timezone).format('YYYY/MM/DD HH:mm')
        return utc_time*!/
      // } else false
    }*/
    //returns current selected order
    selected_order: state => (state.order ? state.order : {}),

    //returns current order type, either its call-center
    order_type: state => state.orderType,
    order_id: state => state.orderId,
    cart_warning: state => state.storeChangeWarn,
    //return all items added to the cart
    cart_items: (state, getters) => {
      //apply discounts here
      return state.items.map(item => {
        //console.log('origin item')
        //console.log({...item})
        const menuItem = getters.menu_items.find(
          menuItem => menuItem._id === item._id
        )
        const newItem = { ...menuItem }
        //console.log('new item')
        //console.log(newItem)

        //reprice item based on current store
        newItem.store_id = item.store_id
        newItem.brand_id = item.brand_id
        newItem.quantity = item.quantity
        newItem.note = item.note
        newItem.index = item.index
        //retain modifiers
        newItem.modifiers = item.modifiers.map(modifier => {
          const menuModifier = getters.all_item_modifiers.find(
            menuMod => menuMod._id === modifier._id
          )
          const newModifier = { ...menuModifier }
          //console.log('old modifier', {...modifier})
          //console.log('new modifier', newModifier)
          newModifier.type = modifier.type
          newModifier.no_of_selection = modifier.no_of_selection
          return newModifier
        })
        const modifiedItem = Item.cartCalculations(newItem, getters)
        //console.log('modified item')
        //console.log(modifiedItem)
        return modifiedItem
      })
    },
    //return total items added in cart i.e 3
    cart_items_count: state => state.items.length,
    //return items prices + modifiers prices + discount applied
    cart_sub_total: (state, getters) =>
      getters.available_cart_items.reduce(
        (total, item) => Num.add(total, item.collectivePrice),
        0
      ),
    cart_sub_total_all: (state, getters) =>
      getters.cart_items.reduce(
        (total, item) => Num.add(total, item.collectivePrice),
        0
      ),

    cart_sub_total_price_override: (state, getters) => {
      // console.log(getters.available_cart_items.filter(item => item.price_override == undefined))
      let collectivePrice = Num.round(
        getters.available_cart_items
          .filter(m_item => m_item.price_override == true)
          .reduce((total, item) => Num.add(total, item.collectivePrice), 0)
      )
      let price_not_override = getters.available_cart_items.filter(
        m_item => !m_item.price_override
      )
      if (price_not_override.length) {
        let amount = price_not_override.reduce(
          (total, item) => Num.add(total, item.collectivePrice),
          0
        )
        collectivePrice += parseFloat(Num.price(amount))
      }

      return collectivePrice
    },
    //returns tip added for driver
    driver_tip: (state, getters) => {
      if (state.driverTip) {
        if (Num.isNumber(state.driverTip)) {
          return Num.round(state.driverTip)
        }

        if (state.driverTip.match('%')) {
          return Num.round(
            (getters.cart_sub_total *
              parseFloat(state.driverTip.replace('%', ''))) /
              100
          )
        }
      }
      return 0
    },
    modifier_errors: state => state.modifierErrors,
    cashback: (state, getters) => {
      /* will remove later this*/
      if (getters.domainBasedBrand) {
        if (Num.isNumber(state.loyalty)) {
          return state.loyalty
        }

        if (state.loyalty.match('%')) {
          return Num.round(
            (getters.cart_net_sub_total *
              parseFloat(state.loyalty.replace('%', ''))) /
              100
          )
        }
      }
      return 0
    },

    // get tax price only
    tax_price: () => (taxSum, price) => {
      return Num.round(price + (price * taxSum) / 100)
    },
    item_price_set_currency: (state, getters) => item => {
      /*this function for deep level price exchange rate */
      if (!item.price_availability) return item
      let update_menu_price = Object.assign({}, item)
      let current_brand_base_country = getters.currentBrand.country
      let current_store_country = getters.currentStore
      let has_store_price = false
      let has_city_price = false
      let current_country = getters.selectedCountry
      let has_same_country = current_brand_base_country === current_country
      let has_country_price = false
      if (has_same_country) {
        update_menu_price.price_availability.stores.map(store => {
          if (store.param === current_store_country._id) {
            update_menu_price.value = store.value
            update_menu_price.price_override = false
            has_store_price = true
          }
        })
        if (!has_store_price) {
          update_menu_price.price_availability.cities.map(city => {
            if (city.param === current_store_country.city) {
              update_menu_price.value = city.value
              update_menu_price.price_override = false
              has_city_price = true
            }
          })
        }
      }
      if (!has_city_price && !has_store_price) {
        update_menu_price.price_availability.countries.map(country => {
          if (country.param === getters.selectedCountry) {
            update_menu_price.value = country.value
            update_menu_price.price_override = true
            has_country_price = true
          }
          /* If price set on only country then below handle will work*/
          if (
            !update_menu_price.value &&
            country.param === current_brand_base_country
          ) {
            update_menu_price.value = country.value
            update_menu_price.price_override = false
            has_country_price = true
          }
          if (!has_country_price) {
            update_menu_price.price_override = false
          }
        })
      }
      return update_menu_price
    },
    exchange_rate: (state, getters) => country => {
      let currency = country
        ? getters.get_currencies(country)
        : getters.get_currencies(getters.selectedCountry)
      return currency ? currency.exchange_rate : 1
    },
    exchange_price: (state, getters) => (value, exchange = true) => {
      /*  before getters.currentBrand.country current brand country I was taken country by currentStore.
       * When we set price on only country not for an store it will not show price*/
      /*let current_brand_country = getters.currentBrand
        ? getters.currentBrand.country
        : 'AE'*/
      // eslint-disable-next-line no-unused-vars
      let current_store_country = getters.currentStore
        ? getters.currentStore.country
        : getters.selectedCountry
      let currentCountry =
        getters.selectedCountry || localStorage.getItem('selectedCountry')
      if (current_store_country != currentCountry) {
        let converstion_by = exchange ? current_store_country : currentCountry
        let price_on_aed = getters.reverse_exchange_price(value, converstion_by)
        return getters.multiply_exchange_price(price_on_aed, exchange)
      } else {
        return getters.multiply_exchange_price(value, false)
      }
    },
    multiply_exchange_price: (state, getters) => (value, exchange = true) => {
      if (exchange) return value * getters.exchange_rate(undefined)
      else return value
    },
    reverse_exchange_price: (state, getters) => (
      price,
      country = undefined
    ) => {
      let exchange_rate = getters.exchange_rate(country)
      return parseFloat(price) / exchange_rate
    },
    //this retrurn all modifiers selected with current item (state.item) (cart plus icon
    selected_modifiers: (state, getters) => {
      let modifiers = []
      for (let id in state.selectedModifiers) {
        let modifierId = undefined
        let noOfSelection = undefined
        if (typeof state.selectedModifiers[id] === 'boolean') {
          //checkbox: id contains the modifier id
          modifierId = id
        } else {
          //radio: id contains the subgroupId and value contains the modifier id
          noOfSelection = 1
          modifierId = state.selectedModifiers[id]
        }
        let modifierEntity = getters.find_item_modifier_by_main_id(modifierId)
        let modifierType = ''

        //we may lose the data from collection as we move back to homepage where there is no store id
        if (modifierEntity) {
          modifierType = getters.find_item_modifier_subgroup_by_main_id(
            modifierEntity.modifier_sub_group
          ).item_type
        } else {
          modifierEntity = state.selectedItem.modifiers.find(
            modifier => modifier._id == modifierId
          )
          modifierType = modifierEntity.type
        }

        const modifier = {
          ...modifierEntity,
          no_of_selection: noOfSelection,
          type: modifierType,
        }
        modifiers.push(modifier)
      }
      return modifiers
    },
    //this price is inclusive tax to show on cart
    item_discounted_collective_cart_price: () => menuItem => {
      let netPrice = menuItem.collectiveNetPriceRounded
      let tax = menuItem.collectiveTaxRounded
      let menuPrice = netPrice + tax

      if (!menuItem.cartDiscounts.length) {
        return menuPrice * menuItem.quantity
      }

      let discountsTotal = 0
      menuItem.cartDiscounts.forEach(discount => {
        discountsTotal += discount.rounded.price + discount.rounded.tax
      })

      return menuPrice * menuItem.quantity - discountsTotal
    },
    //calculate selected modifiers price for current item
    selected_modifiers_price: (state, getters) =>
      getters.selected_modifiers.reduce(
        (total, modifier) =>
          total + getters.tax_price(state.selectedItem.tax_sum, modifier.value),
        0
      ),
    selected_modifiers_price_exchange: (state, getters) =>
      getters.selected_modifiers.reduce(
        (total, modifier) =>
          total +
          getters.tax_price(
            state.selectedItem.tax_sum,
            getters.exchange_price(modifier.value, true)
          ),
        0
      ),

    //get any item modifiers price pass an item
    item_modifiers_price: (state, getters) => item =>
      item.modifiers
        ? item.modifiers.reduce(
            (total, modifier) =>
              total + getters.tax_price(item.tax_sum, modifier.value),
            0
          )
        : 0,
    item_modifiers_net_price: () => item =>
      item.modifiers
        ? item.modifiers.reduce((total, modifier) => total + modifier.value, 0)
        : 0,
    item_modifiers_tax: () => item =>
      item.modifiers
        ? item.modifiers.reduce(
            (total, modifier) => total + Item.tax(modifier.value, item.tax_sum),
            0
          )
        : 0,

    item_modifiers_tax_rounded: () => item =>
      item.modifiers
        ? item.modifiers.reduce(
            (total, modifier) =>
              total + Item.tax(modifier.value, item.tax_sum, true),
            0
          )
        : 0,

    //get combo sub item price with respective item
    combo_item_modifiers_price: (state, getters, rootState) => item => {
      let comboModifiers =
        rootState.combo_items_store.itemsModifiersValueTaxDiff
      let itemId = item._id + item.index //|| item.orderIndex).toString()
      //need to check with new items and old combo items, if new then orderIndex else item.no
      if (comboModifiers.length > 0) {
        let comboItemPrice = comboModifiers.find(
          cmb_item_modifier_amount => cmb_item_modifier_amount.itemId === itemId
        )
        return comboItemPrice || { price: 0, net_price: 0, tax: 0 }
      } else {
        return { price: 0, net_price: 0, tax: 0 }
      }
    },

    cashback_balance: (state, getters) =>
      getters.exchange_price(getters.loyalty_balance),
    //item price + tax + (surcharge price + tax) + all type of discounts + modifiers price (final price)
    //keep in mind, order discount depends on surcharge, so surcharge calculation should come first in order
    order_total_inc_cashback: (state, getters) => {
      return getters.order_total - getters.loyalty_spent
    },
    order_total_inc_cashback_price_override: (state, getters) => {
      // return getters.cart_sub_total_price_override - Num.price(getters.loyalty_spent)
      let order_surcharge_converted = Num.price(
        getters.order_surcharge_total + getters.order_surcharge_tax
      )
      let total_amount = Num.add(
        getters.cart_sub_total_price_override,
        order_surcharge_converted,
        getters.delivery_surcharge,
        getters.driver_tip
      )
      let divide_amount =
        getters.discount_on_order + parseFloat(Num.price(getters.loyalty_spent))
      return parseFloat(total_amount - divide_amount)

      /*parseFloat(parseFloat(getters.cart_sub_total_price_override) + parseFloat(getters.order_surcharge_total) +
          parseFloat(getters.order_surcharge_tax) +
          parseFloat(getters.delivery_surcharge) +
          parseFloat(getters.driver_tip)) - (getters.discount_on_order + Num.price(getters.loyalty_spent))*/
    },
    order_total: (state, getters) => {
      // eslint-disable-next-line no-console
      console.log(
        'getters.cart_net_sub_total',
        getters.cart_net_sub_total,
        'getters.cart_sub_total_tax',
        getters.cart_sub_total_tax,
        'getters.order_surcharge_total',
        getters.order_surcharge_total,
        'getters.order_surcharge_tax',
        getters.order_surcharge_tax,
        'getters.driver_tip',
        getters.driver_tip,
        'getters.cashback',
        getters.cashback,
        'getters.discount_on_order',
        getters.discount_on_order
      )
      if (!getters.cart_items_count) {
        return 0
      }
      return (
        Num.add(
          getters.cart_net_sub_total,
          getters.cart_sub_total_tax,
          getters.order_surcharge_total,
          getters.order_surcharge_tax,
          getters.delivery_surcharge,
          getters.driver_tip
        ) - getters.discount_on_order
      )
    },

    //all surcharges collections (API DATA which applies to current order)
    surcharges_collection: (state, getters) =>
      getters.all_additional_surcharges.filter(
        surcharge => surcharge[state.orderType]
      ),

    // get total surcharge amount + surcharge tax applied on current on current order
    order_surcharges: (state, getters) => {
      let appliedSurcharge = []
      if (!getters.cart_items_count) {
        return appliedSurcharge
      }

      getters.surcharges_collection.forEach(surcharge => {
        if (surcharge.type === 'percentage' && surcharge.rate) {
          let amount = Num.round(
            (getters.cart_net_sub_total * surcharge.rate) / 100
          )

          let tax = Num.round(
            surcharge.tax_sum ? (amount * surcharge.tax_sum) / 100 : 0
          )
          if (amount) {
            appliedSurcharge.push({
              entity: surcharge,
              surcharge: amount,
              tax: tax,
            })
          }
        } else if (surcharge.value) {
          appliedSurcharge.push({
            entity: surcharge,
            surcharge: surcharge.value,
            tax:
              surcharge.value && surcharge.tax_sum
                ? Num.round((surcharge.value * surcharge.tax_sum) / 100)
                : 0,
          })
        }
      })
      return appliedSurcharge
    },
    order_has_item_discounts: state =>
      state.items.some(item => item.cartDiscounts && item.cartDiscounts.length),
    order_discounts: (state, getters) => {
      if (!getters.cart_items_count) {
        return false
      }

      let orderDiscounts = []

      if (!getters.order_has_item_discounts) {
        orderDiscounts = getters.all_order_discounts.filter(discount => {
          if (discount[getters.order_type]) {
            return getters.availabeByTime(discount)
          }
        })
      }

      if (getters.coupon_discount) {
        orderDiscounts.push(getters.coupon_discount)
      }
      return orderDiscounts
    },
    discounts_on_order_breakdown: (state, getters) => {
      let breakdown = []

      let orderSubTotal = getters.cart_net_sub_total
      let orderTaxTotal = getters.cart_sub_total_tax
      let orderSurcharge = getters.order_surcharge_total
      let orderSurchargeTax = getters.order_surcharge_tax

      let orderTotal = orderSubTotal + orderTaxTotal
      let orderTotalIncSurcharge =
        orderTotal + orderSurcharge + orderSurchargeTax

      let totalDiscountApplied = { price: 0, tax: 0 }

      if (getters.order_discounts && getters.order_discounts.length) {
        getters.order_discounts.forEach(discount => {
          let discountCandidate = undefined

          if (discount.include_surcharge) {
            //discount applied on surcharge tax is also included in discountApplied.tax

            if (
              totalDiscountApplied.price + totalDiscountApplied.tax <
              orderTotalIncSurcharge
            ) {
              discountCandidate = getters.discount_on_order_including_surcharge(
                discount
              )
              if (discountCandidate) {
                //now we have got a discountCandidate which is supposed to be applied and it includes discount on surcharge + tax
                totalDiscountApplied.price += discountCandidate.price
                totalDiscountApplied.tax += discountCandidate.tax

                if (
                  totalDiscountApplied.price >
                  orderSubTotal + orderSurcharge
                ) {
                  discountCandidate.price -=
                    totalDiscountApplied.price - orderSubTotal - orderSurcharge
                }
                if (
                  totalDiscountApplied.tax >
                  orderTaxTotal + orderSurchargeTax
                ) {
                  discountCandidate.tax -=
                    totalDiscountApplied.tax - orderTaxTotal - orderSurchargeTax
                }
              }
            }
          } else {
            if (
              totalDiscountApplied.price + totalDiscountApplied.tax <
              orderTotal
            ) {
              discountCandidate = getters.discount_on_order_excluding_surcharge(
                discount
              )
              if (discountCandidate) {
                //now we have got a discountCandidate which is supposed to be applied and it DOES NOT include discount on surcharge + tax
                totalDiscountApplied.price += discountCandidate.price
                totalDiscountApplied.tax += discountCandidate.tax

                if (totalDiscountApplied.price > orderSubTotal) {
                  discountCandidate.price -=
                    totalDiscountApplied.price - orderSubTotal
                }
                if (totalDiscountApplied.tax > orderTaxTotal) {
                  discountCandidate.tax -=
                    totalDiscountApplied.tax - orderTaxTotal
                }
              }
            }
          }

          if (discountCandidate) {
            discountCandidate.price = Num.round(discountCandidate.price)
            discountCandidate.tax = Num.round(discountCandidate.tax)
            breakdown.push(discountCandidate)
          }
        })
      }
      return breakdown
    },
    validate_discount: (state, getters) => (discount, errors) => {
      if (discount.include_surcharge) {
        //discount applied on surcharge tax is also included in discountApplied.tax
        return getters.discount_on_order_including_surcharge(discount, errors)
      } else {
        return getters.discount_on_order_excluding_surcharge(discount, errors)
      }
    },
    total_cart_item_discount_price: (state, getters) =>
      getters.available_cart_items.reduce(
        (total, item) =>
          total +
          item.cartDiscounts.reduce(
            (total, discount) => total + (discount.rounded.price || 0),
            0
          ),
        0
      ),
    total_cart_item_discount_tax: (state, getters) =>
      getters.available_cart_items.reduce(
        (total, item) =>
          total +
          item.cartDiscounts.reduce(
            (total, discount) => total + (discount.rounded.tax || 0),
            0
          ),
        0
      ),
    net_discount_on_order: (state, getters) =>
      getters.discounts_on_order_breakdown.reduce(
        (total, discount) => total + discount.price,
        0
      ),
    tax_discount_on_order: (state, getters) =>
      getters.discounts_on_order_breakdown.reduce(
        (total, discount) => total + discount.tax,
        0
      ),

    discount_on_order: (state, getters) =>
      getters.net_discount_on_order + getters.tax_discount_on_order,

    get_order_discount_item_amount: (state, getters) => item => {
      let items = getters.available_cart_items
      let net_discount_on_order = getters.discount_on_order
      let sub_total = getters.cart_net_sub_total + getters.cart_sub_total_tax
      let order_discounts = (net_discount_on_order * 100) / sub_total
      // let order_discounts = getters.all_order_discounts.find(disocunt => !disocunt.manual)
      let item_amount = 0
      if (items.length > 0) {
        item_amount =
          (item.value * item.quantity * parseFloat(100 - order_discounts)) / 100
        // item_amount = ((item.value * item.quantity) * parseFloat(order_discounts)) / 100
        /*console.log(item, order_discounts, 'order_discounts', getters.cart_net_sub_total, getters.cart_sub_total_tax)
        if (order_discounts.type === "percentage" ) {
          // let discount_for_single_item = parseFloat(discount_amount) / items.length
          item_amount = ((item.quantity * item.value) * parseFloat(100 - order_discounts.rate)) / 100
        } else {
          let total_item_amount = getters.cart_net_sub_total + getters.cart_sub_total_tax
          let discount_percent = (100 * order_discounts.value) / total_item_amount
          item_amount = ((item.quantity * item.value) * parseFloat(100 - discount_percent)) / 100
        }*/
        return item_amount
      } else {
        return item_amount
      }
    },
    find_net_discount_on_order: (state, getters) => discountUnit =>
      getters.discounts_on_order_breakdown.reduce((total, discount) => {
        if (discountUnit._id == discount.entity._id) {
          return total + discount.price
        }
        return total
      }, 0),

    find_tax_discount_on_order: (state, getters) => discountUnit =>
      getters.discounts_on_order_breakdown.reduce((total, discount) => {
        if (discountUnit._id == discount.entity._id) {
          return total + discount.tax
        }
        return total
      }, 0),

    find_discount_on_order: (state, getters) => discountUnit =>
      getters.find_net_discount_on_order(discountUnit) +
      getters.find_tax_discount_on_order(discountUnit),

    cart_net_sub_total: (state, getters) => {
      return (
        getters.available_cart_items.reduce(
          (total, item) =>
            Num.add(total, item.collectiveNetPriceRounded * item.quantity),
          0
        ) - getters.total_cart_item_discount_price
      )
    },
    //note: there is not collective tax so calculate based on quantity here
    cart_sub_total_tax: (state, getters) => {
      return (
        getters.available_cart_items.reduce(
          (total, item) =>
            total +
            (item.rounded.tax + item.additionalTaxRounded) * item.quantity,
          0
        ) - getters.total_cart_item_discount_tax
      )
    },
    discount_on_order_including_surcharge: (state, getters) => (
      discount,
      errors
    ) => {
      if (discount.type == CONST.DISCOUNT_TYPE_PERCENTAGE) {
        //handle min and max discount
        if (discount.min_cart_value <= getters.cart_net_sub_total) {
          const discountOnNetPrice = Num.round(
            (getters.cart_net_sub_total + getters.order_surcharge_total) *
              discount.rate *
              0.01
          )
          const discountOnTax = Num.round(
            (getters.cart_sub_total_tax + getters.order_surcharge_tax) *
              discount.rate *
              0.01
          )
          //if max discount and current discount > max discount, apply max discount
          if (
            discount.max_discount_value &&
            discountOnNetPrice + discountOnTax > discount.max_discount_value
          ) {
            //max discount should be applied here
            const percentDiscountApplied =
              (discount.max_discount_value /
                (getters.cart_net_sub_total + getters.order_surcharge_total)) *
              100
            const discountOnTax = Num.round(
              (getters.cart_sub_total_tax + getters.order_surcharge_tax) *
                percentDiscountApplied *
                0.01
            )
            return {
              entity: discount,
              price: discount.max_discount_value - discountOnTax,
              tax: discountOnTax,
            }
          } else {
            //apply current discount
            return {
              entity: discount,
              price: discountOnNetPrice,
              tax: discountOnTax,
            }
          }
        } else {
          if (errors && errors.error) {
            errors.error = `Minimum Item Total should be ${discount.min_cart_value}`
          }
        }
      } else if (discount.type == CONST.DISCOUNT_TYPE_VALUE) {
        if (getters.cart_net_sub_total >= discount.value) {
          const percentDiscountApplied = Num.round(
            (discount.value /
              (getters.cart_net_sub_total + getters.order_surcharge_total)) *
              100
          )
          const discountOnTax = Num.round(
            (getters.cart_sub_total_tax + getters.order_surcharge_tax) *
              percentDiscountApplied *
              0.01
          )
          return { entity: discount, price: discount.value, tax: discountOnTax }
        } else {
          if (errors && errors.error) {
            errors.error = `Minimum Item Total should be ${discount.min_cart_value}`
          }
        }
      }
    },
    discount_on_order_excluding_surcharge: (state, getters) => (
      discount,
      errors
    ) => {
      if (discount.type == CONST.DISCOUNT_TYPE_PERCENTAGE) {
        if (discount.min_cart_value <= getters.cart_net_sub_total) {
          const discountOnNetPrice = Num.round(
            getters.cart_net_sub_total * discount.rate * 0.01
          )
          const discountOnTax = Num.round(
            getters.cart_sub_total_tax * discount.rate * 0.01
          )
          //if max discount and current discount > max discount, apply max discount
          if (
            discount.max_discount_value &&
            discountOnNetPrice + discountOnTax > discount.max_discount_value
          ) {
            //max discount should be applied here
            const percentDiscountApplied =
              (discount.max_discount_value / getters.cart_net_sub_total) * 100
            const discountOnTax = Num.round(
              getters.cart_sub_total_tax * percentDiscountApplied * 0.01
            )
            return {
              entity: discount,
              price: discount.max_discount_value - discountOnTax,
              tax: discountOnTax,
            }
          } else {
            //apply current discount
            return {
              entity: discount,
              price: discountOnNetPrice,
              tax: discountOnTax,
            }
          }
        } else {
          if (errors && errors.error) {
            errors.error = `Minimum Item Total should be ${discount.min_cart_value}`
          }
        }
      } else if (discount.type == CONST.DISCOUNT_TYPE_VALUE) {
        if (getters.cart_net_sub_total >= discount.value) {
          const percentDiscountApplied =
            (discount.value / getters.cart_net_sub_total) * 100
          const discountOnTax = Num.round(
            getters.cart_sub_total_tax * percentDiscountApplied * 0.01
          )
          return { entity: discount, price: discount.value, tax: discountOnTax }
        } else {
          errors.error = `Minimum Item Total should be ${discount.value}`
        }
      }
    },
    //get only surcharge total
    order_surcharge_total: (state, getters) =>
      getters.order_surcharges.reduce(
        (total, surcharge) => total + surcharge.surcharge,
        0
      ),

    //get only surcharge tax
    order_surcharge_tax: (state, getters) =>
      getters.order_surcharges.reduce(
        (total, surcharge) => total + surcharge.tax,
        0
      ),

    order_address_instructions: state => {
      return state.addressInstructions
    },
    order_source: (state, getters) =>
      getters.domainBasedBrand ? 'online' : 'go_order',
    go_order_customer_id: (state, getters) =>
      getters.domainBasedBrand
        ? ''
        : getters.web_user
        ? getters.web_user.id
        : undefined,

    order_note: state => state.orderNote,
    item_note: state => state.orderNote,
    delivery_surcharge: (state, getters) => {
      const deliveryAreas = getters.brand_all_delivery_areas.filter(
        bDa => bDa.delivery_area == getters.selectedDaId
      )
      let surcharge = 0
      if (deliveryAreas.length) {
        surcharge = deliveryAreas[0].special_order_surcharge
        if (getters.currentStoreId) {
          const deliveryArea = deliveryAreas.find(
            da => da.store_id == getters.currentStoreId
          )
          if (deliveryArea) {
            surcharge = deliveryArea.special_order_surcharge
          }
        }
      }
      return surcharge
    },
    min_order_value: (state, getters) =>
      getters.storeDAforCustomerAddress
        ? getters.storeDAforCustomerAddress.min_order_value
        : 0,

    cart_brand: (state, getters) => {
      let storeId = undefined
      let brandId = undefined
      if (getters.cart_items_count) {
        storeId = getters.available_cart_items[0].store_id
        brandId = getters.available_cart_items[0].brand_id
        //check if store acting as brand
        return getters.acting_brand({ storeId: storeId, brandId: brandId })
      }
      return {}
    },
    // cart_store: (state, getters) => {
    //   let storeId = undefined
    //   if (getters.cart_items_count) {
    //     storeId = getters.available_cart_items[0].store_id
    //     return getters.find_store_by_main_id(storeId)
    //   }
    //   return {}
    // },
    cart_brand_store: (state, getters) => {
      let data = {
        brand_id: getters.currentBrandId,
        store_id: getters.currentStoreId,
        brand: getters.currentBrand,
        store: getters.currentStore,
      }

      if (getters.available_cart_items.length) {
        data['brand_id'] =
          getters.available_cart_items[0].brand_id || getters.currentBrandId
        data['store_id'] =
          getters.available_cart_items[0].store_id || getters.currentStoreId
        data['brand'] =
          getters.currentBrand ||
          getters.find_brand_by_main_id(data['brand_id'])
        data['store'] =
          getters.currentStore ||
          getters.find_store_by_main_id(data['store_id'])
      }
      //overriding
      if (getters.selectedCheckoutStore) {
        data['store_id'] = getters.selectedCheckoutStore._id
      }
      return data
    },
    order_api_endpoint: (state, getters) => {
      return getters.order_post_request_url
        .replace('{brand_id}', getters.cart_brand_store.brand_id)
        .replace('{store_id}', getters.cart_brand_store.store_id)
    },
    is_old_cart_item: (state, getters) => item_id => {
      if (getters.track_order_data && getters.track_order_data.items.length) {
        return getters.track_order_data.items.find(
          item => item.entity_id === item_id
        )
      } else false
    },
    // reservation_api_endpoint: (state, getters) => {
    //   return getters.dinein_reservation_request_url
    //     .replace('{brand_id}', getters.cart_brand_store.brand_id)
    //     .replace('{store_id}', getters.cart_brand_store.store_id)
    // },
  },
  actions: {
    removeUnavailableItems({ dispatch, getters }) {
      getters.unavailable_cart_items.forEach(item => {
        dispatch('removeItemFromCart', item)
      })
    },
    // revalidateCartItems({ state, getters, commit, dispatch }) {
    //   //get all cart items 1 by 1
    //   //check if item id exist in current store
    //   //if no, add item to missing list and continue to next
    //   //if yes check if item has modifiers
    //   //--if do not have modifiers then add item to cart
    //   //--if has modifiers then check if modifiers exist in current store
    //   //----if yes then add item to cart along with modifiers
    //   //----if no then add item and modifiers to missing list
    //   const missingItems = []
    //   const cartItems = getters.available_cart_items
    //   commit('CLEAR_CART')

    //   cartItems.forEach(citem => {
    //     const item = getters.all_store_menu_items.find(
    //       _item => _item._id === citem._id
    //     )
    //     if (!item) {
    //       missingItems.push(item)
    //     } else {
    //       if (citem.modifiers && citem.modifiers.length) {
    //         if (
    //           citem.modifiers.every(modifier => {
    //             return getters.all_item_modifiers.find(
    //               _modifier => _modifier._id == modifier._id
    //             )
    //           })
    //         ) {
    //           dispatch('restoreCartItem', citem).then(menuItem => {
    //             commit('ADD_ITEM_TO_CART', Item.prepare(state, menuItem))
    //           })
    //         } else {
    //           missingItems.push(citem)
    //         }
    //       } else {
    //         dispatch('restoreCartItem', citem).then(menuItem => {
    //           commit('ADD_ITEM_TO_CART', Item.prepare(state, menuItem))
    //         })
    //       }
    //     }
    //   })
    // },
    async getOrderById({ getters, commit }, orderId) {
      commit('SET_ORDER', {})
      await axios
        .get(`${getters.get_single_order_api_url}${orderId}`)
        .then(resp => {
          commit('SET_ORDER', resp.data.item)
        })
    },

    // eslint-disable-next-line no-unused-vars
    validateCart: ({ getters, commit }, item) => {
      if (
        getters.available_cart_items.some(
          cartItem => cartItem.store_id !== getters.currentStoreId
        )
      ) {
        commit('CLEAR_CHECKOUT')
        return Promise.reject()
      }
      return Promise.resolve()
    },
    addItemToCart: ({ state, getters, dispatch, commit }, item) => {
      return new Promise(resolve => {
        dispatch('validateCart', item).finally(() => {
          let menuItem = { ...item }
          menuItem.store_id = getters.currentStoreId
          menuItem.brand_id = getters.currentBrandId
          menuItem.quantity = state.qty
          menuItem.note = state.itemNote
          let mutation = 'ADD_ITEM_TO_CART'
          if (typeof item.index !== 'undefined') {
            mutation = 'UPDATE_ITEM_IN_CART'
          }
          commit(mutation, Item.prepare(state, menuItem))
          Item.saveCart(state)
          resolve()
        })
      })
    },
    removeItemFromCart: ({ state, getters, commit, dispatch }, item) => {
      commit('REMOVE_ITEM', item.index)
      if (!getters.cart_items_count) {
        commit('CLEAR_CART', item.index)
        dispatch('resetCoupon')
      }
      Item.saveCart(state)
    },
    // get data from index db while refresh page
    restoreCart: ({ state, dispatch }) => {
      if (state.items.length) {
        return false
      }
      Item.resotreCart()
        .then(items => {
          dispatch('reAddItemsToCart', items)
        })
        .catch(() => {
          //do nothing
        })
    },
    reAddItemsToCart({ state, commit, dispatch }, items = []) {
      if (items) {
        items.forEach(item => {
          if (item.entity_id) {
            dispatch('reOrderItem', item).then(menuItem => {
              commit('ADD_ITEM_TO_CART', Item.prepare(state, menuItem))
            })
          } else {
            dispatch('restoreCartItem', item).then(menuItem => {
              commit('ADD_ITEM_TO_CART', Item.prepare(state, menuItem))
            })
          }
        })
      }
    },
    reOrderItem({ getters, dispatch }, item) {
      return new Promise((resolve, reject) => {
        dispatch('load_brand_menu_items').then(() => {
          setTimeout(() => {
            let menuItem = getters.find_store_menu_item_by_main_id(
              item.entity_id
            )

            if (!menuItem) {
              reject()
            }

            resolve({
              ...getters.prepare_menu_item(
                Item.restoreItemData({ ...menuItem }, item, getters)
              ),
            })
          }, 1000)
          // setTimeout(() => {dispatch('resolveProduct')}, 100)
        })
      })
    },
    restoreCartItem({ getters }, item) {
      let menuItem = getters.find_store_menu_item_by_main_id(item._id)
      if (!menuItem) {
        menuItem = item
      }
      let itemToRestore = { ...menuItem }
      if (!itemToRestore.netPrice) {
        itemToRestore = getters.prepare_menu_item(itemToRestore)
      }
      return Promise.resolve(Item.restoreItemData(itemToRestore, item, getters))
    },
    restoreCartItemBySlug({ getters }, item_slug) {
      let menuItem = getters.find_store_menu_item_by_slug(item_slug)
      if (!menuItem) {
        return false
      }
      let itemToRestore = { ...menuItem }
      let item = menuItem
      if (!itemToRestore.netPrice) {
        itemToRestore = getters.prepare_menu_item(itemToRestore)
      }
      return Promise.resolve(Item.restoreItemData(itemToRestore, item, getters))
    },
    // add selected modifiers to current item
    selectModifiers({ commit }, { type, subgroupId, modifiers }) {
      commit('SELECT_MODIFIERS', { type, subgroupId, modifiers })
    },
    // eslint-disable-next-line no-unused-vars
    postOrderHook({ state, getters, dispatch, commit }) {
      // dispatch('orderTracking', state.order.id, { root: true })
      commit('ORDER_NOTE', undefined)
      commit('SET_CARD_MODEL', false, { root: true })
      dispatch('load_orders', true) // Load all orders when a new order is placed
      if (getters.loyalty_spent) {
        dispatch('load_customer')
      }
      commit('SET_GUEST_INFO', {})
      commit('SET_USER_STREET', {
        nearest_landmark: '',
        street: '',
        building: '',
        flat_number: '',
        lat_lng_available: false,
        location_coordinates: { lat: 0, lng: 0 },
      })

      commit('SET_SELECTED_CHECKOUT_STORE', undefined)
      commit('SET_CUSTOMER_SELECTED_ADDRESS', undefined)
      commit('SET_SELECTED_CITY', undefined)
    },
    async dineinReservation({ getters, commit }) {
      return new Promise((resolve, reject) => {
        // const request = Item.makeApiRequest(getters, dispatch)
        // if (!request) {
        //   return reject('Payment validation failed, please try again later')
        // }
        let tableData = getters.isFloorTableAvailable
        if (!tableData.table_id) {
          return reject("Please do it again, did't find table")
        }
        let headers = {}
        if (getters.domainBasedBrand) {
          headers['DomainName'] = location.hostname
        }
        headers['DomainRoot'] = getBaseUrl()
        const params = {
          //need to set UTC
          start_date: moment()
            .utc()
            .format('YYYY-MM-DD'),
          start_time: moment()
            .utc()
            .format('HH:mm'),
          assigned_table_id: tableData.table_id,
          number_of_guests: 1,
          customers: [],
        }
        axios
          .post(getters.dinein_reservation_request_url, params, {
            headers: headers,
          })
          .then(response => {
            if (response.data.status == 'ok') {
              commit('SET_RESERVATION_RESPONSE', response.data)
              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async checkout({ state, getters, commit, dispatch }) {
      commit('RESET_TRACKING', false)
      commit('MAP_DETAILS', false)
      return new Promise((resolve, reject) => {
        const request = Item.makeApiRequest(getters, dispatch)
        commit('SET_LAST_ORDER_REQUEST', {
          ...request,
          store_id: getters.currentStoreId,
          brand_id: getters.currentBrandId,
        })
        if (!request) {
          return reject('Payment validation failed, please try again later')
        }
        let headers = {}
        if (getters.domainBasedBrand) {
          headers['DomainName'] = location.hostname
        }
        if (request.order_type === 'online') {
          localStorage.setItem('getFloorTableInformation', '')
        }
        headers['DomainRoot'] = getBaseUrl()
        let postOrderEndPoint = getters.order_api_endpoint
        if (getters.order_id && request.order_type != 'online') {
          postOrderEndPoint = getters.order_update_request_url
        }
        axios
          .post(postOrderEndPoint, request, {
            headers: headers,
          })
          .then(response => {
            if (response.data.status == 'ok') {
              commit('SET_ORDER', response.data)
              dispatch('markCustomerUsedCoupon')
              commit('CLEAR_CHECKOUT')

              //remove from the saved cart
              resolve(state.order)
              Item.clearCart()
              dispatch('postOrderHook')
              dispatch('resetPayment')
              // dispatch('load_customer') //update loyalty points in real time after applied,
            } else {
              if (response.data.form_errors) {
                reject(Item.formErrorsToString(response.data.form_errors))
              } else {
                reject(response.data.error)
              }
            }
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {})
      })
    },
  },
  mutations: {
    SET_QUANTITY: (state, qty) => (state.qty = qty),
    SET_FUTURE_DATE_TIME: (state, date_time) =>
      (state.futureOrderDateTime = date_time),
    UPDATE_ITEM_QUANTITY: (state, { index, qty }) => {
      state.items = state.items.map(item => {
        if (item.index === index) {
          item.quantity = qty
          Item.saveCart(state)
        }
        return item
      })
    },
    OPEN_MOBILECART_PAYMENT: state => {
      state.openmobilecartpayment = !state.openmobilecartpayment
    },
    OPEN_CART_SIDEBAR: state => {
      state.openCartSidebar = !state.openCartSidebar
    },
    OPEN_MOBILE_CART: state => {
      state.openMobileCart = !state.openMobileCart
    },
    SELECT_ITEM: (state, item) => {
      state.selectedItem = item
      if (item && item.quantity) {
        state.qty = item.quantity
      } else {
        state.qty = 1
      }
      if (item.modifiers) {
        //check if has modifiers then initialize modifiers
        let modifiers = {}
        item.modifiers.forEach(modifier => {
          if (modifier.no_of_selection === 1) {
            modifiers[modifier.modifier_sub_group] = modifier._id
          } else {
            modifiers[modifier._id] = true
          }
        })
        state.selectedModifiers = modifiers
      }
      state.itemNote = item.note
    },
    ADD_ITEM_TO_CART: (state, item) => {
      state.selectedItem = item
      state.items.push(state.selectedItem)
      //reset modifiers
      state.selectedModifiers = {}
    },

    REMOVE_ITEM: (state, index) => {
      state.items = state.items.filter(item => item.index !== index)
      state.selectedModifiers = {}
    },
    CLEAR_CART: (state, partial) => {
      state.items = []
      Item.clearCart()
      if (!partial) {
        state.selectedModifiers = {}
      }
    },
    CLEAR_CHECKOUT: state => {
      state.items = []
      state.selectedModifiers = {}
      state.selectedItem = undefined
      state.qty = 1
      state.driverTip = ''
      state.loyalty = ''
      state.addressInstructions = ''
      state.futureOrderDateTime = undefined
      Item.clearCart()
    },
    SELECT_MODIFIERS: (state, modifiers) =>
      (state.selectedModifiers = modifiers),
    SET_TIP: (state, tip) => (state.driverTip = tip),
    UPDATE_ITEM_IN_CART: (state, newItem) => {
      state.items = state.items.map(item => {
        if (item.index === newItem.index) {
          return newItem
        }
        return item
      })
    },
    ORDER_ADDRESS_INSTRUCTIONS: (state, addressInstructions) => {
      state.addressInstructions = addressInstructions
    },
    SET_ORDER: (state, data) => (state.order = data),
    SET_ORDER_TYPE: (state, order_type) => {
      state.orderType = order_type
    },
    SET_ORDER_ID: (state, order_id) => (state.orderId = order_id),
    SET_RESERVATION_RESPONSE: (state, reservationResponse) =>
      (state.reservationResponse = reservationResponse),
    ORDER_NOTE: (state, note) => (state.orderNote = note),
    ITEM_NOTE: (state, note) => (state.itemNote = note),
    MODIFIER_ERRORS: (state, errors) => (state.modifierErrors = errors),
    STORE_CHANGE_WARN: (state, status) => (state.storeChangeWarn = status),
    SET_LAST_ORDER_REQUEST: (state, data) => (state.lastOrderRequest = data),
  },
}
